import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from '@components/Input';
import {
    setWoodConnectionPattern,
    setWoodConnectionNValue,
    setWoodConnectionLoadType,
    setWoodConnectionKmodFactor
} from '@reducers/selectors/loads/actions';
import { unitLabel, unitTransform } from '@services/helper.service';
import { APP_TYPES, defaultUnits } from '@config';
import { loadTypes } from '../GeneralLoading/DesignLoading/misc/combination.class';
import { APP_TEXTS } from '@texts';
import { NAILPATTERN_TYPES } from '@reducers/selectors/loads';
import './styles.scss';
import { setPanelOptions } from '@reducers/options/panel/actions';

const KMOD_FACTOR_OPTIONS = [0.6, 0.65, 0.7, 0.8, 0.9, 1.1];

class WoodConnectionLoads extends Component {

  handleLoadValueUpdate = (value) => {
    const { setLoadValue, loadUnit } = this.props;
    const convertedValue = unitTransform(+value, false)
      .from(loadUnit)
      .to(defaultUnits.LOAD);
    setLoadValue(convertedValue);
  };

  handleNValueUpdate = (value) => {
    const { setNValue } = this.props;
    setNValue(Number(value));
  };

  render() {
    const {
      nailPattern,
      nValue,
      loadType,
      upliftLoadFaxd,
      loadUnit,
      setNailPattern,
      setLoadType
    } = this.props;

    return (
      <div className="nail-pattern-section list-type">
        <div className="pattern-options">
          <h4>{APP_TEXTS.WOOD_CONNECTION_NAIL_PATTERN.Content}</h4>
          <div className="radio-group">
            <div className="radio-group__item">
              <input
                id="full-pattern"
                type="radio"
                name="pattern"
                value={NAILPATTERN_TYPES.FULL}
                checked={nailPattern === NAILPATTERN_TYPES.FULL}
                onChange={(e) => setNailPattern(e.target.value)}
              />
              <label htmlFor="full-pattern">
                {APP_TEXTS.WOOD_CONNECTION_FULL_NAILING_PATTERN.Content}
              </label>
            </div>
            <div className="radio-group__item">
              <input
                id="partial-pattern"
                type="radio"
                name="pattern"
                value={NAILPATTERN_TYPES.PARTIAL}
                checked={nailPattern === NAILPATTERN_TYPES.PARTIAL}
                onChange={(e) => setNailPattern(e.target.value)}
              />
              <label htmlFor="partial-pattern">
                {APP_TEXTS.WOOD_CONNECTION_PARTIAL_NAILING_PATTERN.Content}
              </label>
            </div>
          </div>

          {nailPattern === NAILPATTERN_TYPES.PARTIAL && (
            <div className="input-group">
              <label htmlFor="n-value">{APP_TEXTS.WOOD_CONNECTION_LOAD_APPLIED_ON_BRACKET_N.Content}</label>
              <Input
                id="n-value"
                type="number"
                value={nValue}
                onUpdate={this.handleNValueUpdate}
                minValue={Math.ceil(this.props.nailsConfiguration.n * this.props.nailsConfiguration.p * 40 / 100)}
                maxValue={this.props.nailsConfiguration.n * this.props.nailsConfiguration.p - 1}
                className="narrow-input w-80"
              />
            </div>
          )}
        </div>

        <div className="load-section">
          <h4>{APP_TEXTS.WOOD_CONNECTION_LOAD_APPLIED_ON_BRACKET.Content}</h4>
          <div className="load-input-group">
            <label htmlFor="load-type">{APP_TEXTS.WOOD_CONNECTION_UPLIFT_LOAD_FAX_D.Content}</label>
            <select
              id="load-type"
              className="form-control"
              value={loadType}
              onChange={(e) => setLoadType(e.target.value)}
            >
              <option value={loadTypes.STANDARD}>{APP_TEXTS.WOOD_CONNECTION_STATIC_LOAD.Content}</option>
              <option value={loadTypes.SEISMIC}>{APP_TEXTS.WOOD_CONNECTION_SEISMIC_LOAD.Content}</option>
            </select>

            <Input
              id="load-value"
              type="number"
              value={unitTransform(upliftLoadFaxd)
                .from(defaultUnits.LOAD)
                .to(loadUnit)}
              onUpdate={this.handleLoadValueUpdate}
              postfix={unitLabel(loadUnit)}
              className="narrow-input d-flex align-items-center w-80"
            />
          </div>
        </div>

        <div className="load-section">
          <div className="load-input-group">
            <label htmlFor="kmod-factor">{APP_TEXTS.WOOD_CONNECTION_KMOD_FACTOR.Content}</label>
            <select
              id="kmod-factor"
              className="form-control"
              value={this.props.kmodFactor}
              onChange={(e) => this.props.setKmodFactor(+e.target.value)}
            >
              {KMOD_FACTOR_OPTIONS.map(value => (
                <option key={value} value={value}>{value}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }

}

const mapState = (state) => ({
  nailPattern: state.selectors.loads[APP_TYPES.WOOD_CONNECTION].nailPattern,
  nValue: state.selectors.loads[APP_TYPES.WOOD_CONNECTION].nValue,
  loadType: state.selectors.loads[APP_TYPES.WOOD_CONNECTION].loadType,
  upliftLoadFaxd: state.selectors.loads[APP_TYPES.WOOD_CONNECTION].upliftLoadFaxd,
  kmodFactor: state.selectors.loads[APP_TYPES.WOOD_CONNECTION].kmodFactor,
  loadUnit: state.main.units.load,
  nailsConfiguration: state.dimension[APP_TYPES.WOOD_CONNECTION].nailsConfiguration
});

const mapDispatch = dispatch => ({
  setNailPattern: (value) => dispatch(setWoodConnectionPattern(value)),
  setNValue: (value) => dispatch(setWoodConnectionNValue(value)),
  setLoadType: (value) => dispatch(setWoodConnectionLoadType(value)),
  setLoadValue: (value) => dispatch(setPanelOptions({ loads: { faxd: value } })),
  setKmodFactor: (factor) => dispatch(setWoodConnectionKmodFactor(factor))
});

export default connect(mapState, mapDispatch)(WoodConnectionLoads);



// WEBPACK FOOTER //
// ./src/views/Loads/WoodConnectionLoads/index.js